var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.params.value
    ? _c(
        "div",
        [
          _c(
            "div",
            [
              _c(
                "b-button",
                {
                  attrs: { id: "show-btn", size: "sm" },
                  on: {
                    click: function ($event) {
                      return _vm.$bvModal.show(_vm.tempId)
                    },
                  },
                },
                [_vm._v("\n      View Content\n    ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-modal",
            { attrs: { id: _vm.tempId, "hide-header": "", "hide-footer": "" } },
            [
              _c(
                "div",
                {
                  staticClass: "text-left",
                  domProps: { innerHTML: _vm._s(_vm.display) },
                },
                [_vm._v("\n      " + _vm._s(_vm.display) + "\n    ")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "mt-3",
                  attrs: { block: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$bvModal.hide(_vm.tempId)
                    },
                  },
                },
                [_vm._v("\n      Close Me\n    ")]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }